export async function getUserCityLocation({ timeoutMs = 5000 } = {}) {
  const getCityNameFromCoords = async (latitude, longitude) => {
    try {
      const url = new URL('https://nominatim.openstreetmap.org/reverse');
      url.searchParams.set('lat', String(latitude));
      url.searchParams.set('lon', String(longitude));
      url.searchParams.set('format', 'json');
      url.searchParams.set('addressdetails', '1');

      const res = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });
      if (!res.ok) return 'Unknown';

      const data = await res.json();
      const address = data?.address;
      const cityName =
        address?.city ||
        address?.town ||
        address?.village ||
        address?.hamlet ||
        address?.county;

      return cityName || 'Unknown';
    } catch {
      return 'Unknown';
    }
  };

  const coords = await new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) return resolve(null);

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position.coords),
      () => resolve(null),
      { timeout: timeoutMs }
    );
  });

  if (!coords) return 'Unknown';
  return await getCityNameFromCoords(coords.latitude, coords.longitude);
}

